<script context="module">	
    //data shared accross each instance of this componenet
  let filter = {}; 
  let apiUrl = "";
  let count = 5;

  const languages = {'as' : ('Assamese'),
                'bn' : ('Bengali'),
                'en' : ('English'),
                'gu' : ('Gujarati'),
                'hi' : ('Hindi'),
                'kn' : ('Kannada'),
                'ks' : ('Kashmiri'),
                'ml' : ('Malayalam'),
                'mr' : ('Marathi'),
                'ne' : ('Nepali'),
                'or' : ('Oriya'),
                'pa' : ('Punjabi'),
                'sa' : ('Sanskrit'),
                'sd' : ('Sindhi'),
                'ta' : ('Tamil'),
                'te' : ('Telugu'),
                'ur' : ('Urdu'),
                'kok' : ('Konkani'),
                'mai' : ('Maithili'),
                'brx' : ('Bodo'),
                'doi' : ('Dogri'),
                'sat' : ('Santali'),
                'mni' : ('Manipuri or Meithei')};

  export function getFilter() {
	  return filter;
  }

  export function updateFilter(f) {
	filter = {...filter, ...f}
    return filter
  }

  export function getApiUrl() {
	  return apiUrl;
  }

  export function setApiUrl(url) {
    apiUrl = url;
  }

  export function getCount() {
	  return count;
  }

  export function setCount(c) {
    count = c;
  }

  export function getLangs() {
	  return languages;
  }

  export function mapLanguages(course_language) {
     return course_language.map(lang => languages[lang] || lang);
  }
  
</script>
  